export default __webpack_public_path__ + "static/media/invade.fe6f7ff9.gif";